export const FAVORITE_GROUP_NAME = "apt-favorite"

export const GROUP_COLOR_MAP = {
  red: {
    ballColor: "bg-red-500",
    bgColor: "bg-red-50",
    borderColor: "border-red-200",
    textClassName: "text-red-600",
    starColor: "text-red-400",
    ringColor: "ring-red-200"
  },
  orange: {
    ballColor: "bg-orange-500",
    bgColor: "bg-orange-50",
    borderColor: "border-orange-200",
    textClassName: "text-orange-600",
    starColor: "text-orange-400",
    ringColor: "ring-orange-200"
  },
  yellow: {
    ballColor: "bg-yellow-400",
    bgColor: "bg-yellow-50",
    borderColor: "border-yellow-200",
    textClassName: "text-yellow-600",
    starColor: "text-yellow-400",
    ringColor: "ring-yellow-200"
  },
  green: {
    ballColor: "bg-green-500",
    bgColor: "bg-green-50",
    borderColor: "border-green-200",
    textClassName: "text-green-700",
    starColor: "text-green-400",
    ringColor: "ring-green-200"
  },
  teal: {
    ballColor: "bg-teal-500",
    bgColor: "bg-teal-50",
    borderColor: "border-teal-200",
    textClassName: "text-teal-700",
    starColor: "text-teal-400",
    ringColor: "ring-teal-200"
  },
  cyan: {
    ballColor: "bg-cyan-500",
    bgColor: "bg-cyan-50",
    borderColor: "border-cyan-200",
    textClassName: "text-cyan-700",
    starColor: "text-cyan-400",
    ringColor: "ring-cyan-200"
  },
  blue: {
    ballColor: "bg-blue-500",
    bgColor: "bg-blue-50",
    borderColor: "border-blue-200",
    textClassName: "text-blue-700",
    starColor: "text-blue-400",
    ringColor: "ring-blue-200"
  },
  indigo: {
    ballColor: "bg-indigo-500",
    bgColor: "bg-indigo-50",
    borderColor: "border-indigo-200",
    textClassName: "text-indigo-700",
    starColor: "text-indigo-400",
    ringColor: "ring-indigo-200"
  },
  purple: {
    ballColor: "bg-purple-500",
    bgColor: "bg-purple-50",
    borderColor: "border-purple-200",
    textClassName: "text-purple-700",
    starColor: "text-purple-400",
    ringColor: "ring-purple-200"
  },
  pink: {
    ballColor: "bg-pink-500",
    bgColor: "bg-pink-50",
    borderColor: "border-pink-200",
    textClassName: "text-pink-700",
    starColor: "text-pink-400",
    ringColor: "ring-pink-200"
  }
}

export const editorBundle = {
  ko: {
    title: "그룹 관리",
    description: "아파트 그룹을 만들고 이름과 색상을 관리하세요.",
    groups: "등록된 그룹",
    add: "새 그룹",
    edit: "수정",
    save: "저장",
    cancel: "취소",
    delete: "삭제",
    name: "그룹 이름",
    namePlaceholder: "예: 호반, 세종",
    color: "그룹 색상",
    empty: "등록된 그룹이 없습니다.",
    emptyDescription: "새 그룹을 만들어 아파트를 분류해 보세요.",
    createTitle: "새 그룹 만들기",
    editTitle: "그룹 수정",
    confirmDelete: (name) => `"${name}" 그룹을 삭제하시겠습니까?`,
    nameRequired: "그룹 이름을 입력하세요.",
    nameTooLong: "그룹 이름은 100자 이내로 입력하세요.",
    createSuccess: "그룹을 추가했습니다.",
    updateSuccess: "그룹을 수정했습니다.",
    deleteSuccess: "그룹을 삭제했습니다.",
    saveError: "그룹 저장에 실패했습니다.",
    deleteError: "그룹 삭제에 실패했습니다.",
    duplicate: "이미 사용 중인 그룹 이름입니다.",
    close: "닫기"
  },
  en: {
    title: "Group Management",
    description: "Create apartment groups and manage their names and colors.",
    groups: "Your groups",
    add: "New group",
    edit: "Edit",
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    name: "Group name",
    namePlaceholder: "e.g. Hoban, Sejong",
    color: "Group color",
    empty: "No groups yet.",
    emptyDescription: "Create a group to organize apartments.",
    createTitle: "Create a group",
    editTitle: "Edit group",
    confirmDelete: (name) => `Delete the "${name}" group?`,
    nameRequired: "Enter a group name.",
    nameTooLong: "Group names must be 100 characters or fewer.",
    createSuccess: "Group created.",
    updateSuccess: "Group updated.",
    deleteSuccess: "Group deleted.",
    saveError: "Failed to save the group.",
    deleteError: "Failed to delete the group.",
    duplicate: "This group name is already in use.",
    close: "Close"
  },
  es: {
    title: "Administrar grupos",
    description: "Crea grupos de apartamentos y administra sus nombres y colores.",
    groups: "Tus grupos",
    add: "Nuevo grupo",
    edit: "Editar",
    save: "Guardar",
    cancel: "Cancelar",
    delete: "Eliminar",
    name: "Nombre del grupo",
    namePlaceholder: "Ej.: Hoban, Sejong",
    color: "Color del grupo",
    empty: "Todavía no hay grupos.",
    emptyDescription: "Crea un grupo para organizar los apartamentos.",
    createTitle: "Crear un grupo",
    editTitle: "Editar grupo",
    confirmDelete: (name) => `¿Eliminar el grupo "${name}"?`,
    nameRequired: "Introduce un nombre para el grupo.",
    nameTooLong: "El nombre debe tener 100 caracteres o menos.",
    createSuccess: "Grupo creado.",
    updateSuccess: "Grupo actualizado.",
    deleteSuccess: "Grupo eliminado.",
    saveError: "No se pudo guardar el grupo.",
    deleteError: "No se pudo eliminar el grupo.",
    duplicate: "Este nombre de grupo ya está en uso.",
    close: "Cerrar"
  }
}
